module.exports = __webpack_public_path__ + "static/media/12_l_ctul_15.99_84.35.cfafdfae.png";